import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QualValOffering from "@/pages/QualValOffering";

export const Route = createFileRoute("/es/servicios/qualification-validation/validacion-de-limpieza")({
  head: () => buildRouteHead("/es/servicios/qualification-validation/validacion-de-limpieza"),
  component: QualValOffering,
});

